export interface IDocument {
    id: `${IDocumentType}_${number}`;
    type: IDocumentType;
    name: string;
    is_default_selected: boolean;
    updated_at: string;
    preview_urls: { small: string; medium: string; large: string; normal: string };
    vanity_url: string;
    labels: string[];
    labels_color_code: string;
}

export enum IDocumentType {
    document = "document",
    url = "url",
    trackingUrl = "trackingUrl",
}

export enum DocumentsViewMode {
    GRID = "grid",
    LIST = "list",
}
